(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('spTimePicker', spTimePicker);

    /* @ngInject */
    function spTimePicker() {
        var directive = {
            restrict: 'E',
            link: link,
            scope: { 
                'label': '@',
                'controlId': '@',
                'bindTo': '='
            },
            template: '<label for="{{controlId}}">{{label}}</label>' +
                '<select class="form-control" data-ng-model="bindTo" name="{{controlId}}" id="{{controlId}}" >' +
'<option value="{{time.value}}" ng-repeat="time in times" ng-selected="bindTo == time.value" >{{time.text}}</option>' +
'</select>'
        };

        return directive;

        function link(scope, element, attrs) {
            var times = [], i, j, t, h, hh, m;

            for (i = 0; i < 24; i++) {
                hh = i;
                if (i === 0) {
                    h = "12";
                }
                else {
                    if (i > 12) {
                        h = i % 12;
                    }
                    else {
                        h = i;
                    }
                }
                for (j = 0; j < 4; j++) {
                    t = (h + ":" + (j === 0 ? "00" : 15 * j));
                    m = ((hh < 10 ? "0" + hh : hh) + ":" + (j === 0 ? "00" : 15 * j));
                    t += " " + Number(i) < 12 ? " AM" : " PM"
                    times.push({ value: m, text: t });
                }
            }

            scope.times = times;
        }

    }
})();
